/* eslint-disable */
import {
  blueThemeboy,
  blueThemegirl,
  eduBlue,
  expBlue,
  contactsBlue,
} from "./images";

export interface ITheme {
  type: string;
  primary: string;
  primary400: string;
  primary600: string;
  primary80: string;
  primary50: string;
  primary30: string;
  secondary: string;
  secondary70: string;
  secondary50: string;
  tertiary: string;
  tertiary80: string;
  tertiary70: string;
  tertiary50: string;
  aboutimg1: SVGElement;
  aboutimg2: SVGElement;
  eduimg: SVGElement;
  expimg: SVGElement;
  contactsimg: SVGElement;
  selected: boolean;
}

// Single fixed theme derived from the hero photo:
// navy-blue accent, pale stone/sky background, deep-navy text.
export const mainTheme: ITheme = {
  type: "light",
  primary: "#2c4a7c",
  primary400: "#3f5f96",
  primary600: "#213a63",
  primary80: "#2c4a7ccc",
  primary50: "#2c4a7c2e",
  primary30: "#2c4a7c1a",
  secondary: "#eef1f6",
  secondary70: "#eef1f6b3",
  secondary50: "#eef1f680",
  tertiary: "#1b2a44",
  tertiary80: "#1b2a44cc",
  tertiary70: "#1b2a44b3",
  tertiary50: "#1b2a4480",
  aboutimg1: blueThemeboy,
  aboutimg2: blueThemegirl,
  eduimg: eduBlue,
  expimg: expBlue,
  contactsimg: contactsBlue,
  selected: true,
};
